import Typography from "@vapor/react-extended/ExtendedTypography";;
import Grid from "@vapor/react-material/Grid";
import Box from "@vapor/react-material/Box";
import { StatSection } from "./StatComponents";

const AutovalutazioniStatsTab = ({ isLoading, displayStats, riskColors }) => {
    return (
        <>
            {isLoading && 
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                    <Typography>Caricamento dati statistici...</Typography>
                </Box>
            }
            {!isLoading &&
                <>
                    <Typography variant="h5" sx={{ mb: 3, textAlign: 'center', color: '#000000ff', fontSize: '1.25rem' }}>
                        Punteggi delle Autovalutazioni
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <StatSection
                                title="C1 - Esercizio dell'attività in più sedi"
                                stats={displayStats?.c1Punteggio}
                                colors={riskColors}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <StatSection
                                title="C2 - Organico e grado di complessità dell'organizzazione del lavoro"
                                stats={displayStats?.c2Punteggio}
                                colors={riskColors}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <StatSection
                                title="C3 - Impiego di collaboratori esterni"
                                stats={displayStats?.c3Punteggio}
                                colors={riskColors}
                            />
                        </Grid>
                    </Grid>                                           
                </>  
            }
        </>
    );
};

export default AutovalutazioniStatsTab;